import { useEffect } from 'react';
import { useSparks } from '../../contexts/SparksContext';
import { getLeaderboard } from '../../api/sparksApi';
import { beginTally, boardSnapshot, setTallyBoard } from './recapTally';

/** Opens the end-of-lesson recap's tally once `active` (the lesson or its practice questions have started). */
export default function useBeginLessonTally(childId, active) {
  const { loaded, enabled, lifetime, balance } = useSparks();
  useEffect(() => {
    if (!active || !childId || !loaded || !enabled) return;
    const tally = beginTally(childId, { lifetime, balance });
    if (!tally) return;
    getLeaderboard(childId)
      .then((board) => setTallyBoard(childId, tally.at, boardSnapshot(board)))
      .catch(() => {}); // non-fatal: the recap just skips the Sparks Stars line
    // The starting values are read once, when the tally opens; later awards must not reopen it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, childId, loaded, enabled]);
}
